/* eslint-disable no-unused-vars */
// linter gives a false-positive for typescript-enums, needs to investigate
export enum ChatPanelLoadingEnum {
  LOADING = 'loading',
  LOADED = 'loaded',
  FAILED = 'failed',
}
